import { Dispatch, Action } from 'redux'
import { MentionSuggestionListMapDispatchReturnType } from './types/MentionSuggestionListMapDispatchReturnType'

export const MentionSuggestionListMapDispatch = (
  _dispatch: Dispatch<Action>
): MentionSuggestionListMapDispatchReturnType => {
  return {}
}
